import { Injectable } from '@angular/core';

@Injectable()
export class SubtleCryptService {

  constructor() { }

  // Generate a PBKDF2 bits with 1000 iterations using SHA-1
  private generateBits(secret, salt, length): PromiseLike<ArrayBuffer> {
    let encoder = new TextEncoder();
    return crypto.subtle.importKey(
      'raw', 
      encoder.encode(secret), 
      {name: 'PBKDF2', length: length}, 
      false,
      ['deriveBits']
    ).then(function (key) {
      return crypto.subtle.deriveBits({
        name: 'PBKDF2',
        salt: encoder.encode(salt),
        iterations: 25000,
        hash: {
          name: 'SHA-512'
        }
      }, key, length);
    });
  }

  public getRandomIV(length: number): Uint8Array {
    return window.crypto.getRandomValues(new Uint8Array(length));
  }

  public decrypt(data, iv, secret, salt, length): Promise<ArrayBuffer> {
    return new Promise((resolve, reject) => {
      this.generateKey(secret, salt, length).then(
        (key: CryptoKey) => {
          return window.crypto.subtle.decrypt({ name: "AES-CBC", iv: iv }, key, data ).then(data => resolve(data))
        }).catch(error => reject(error));
      });
  }

  public encrypt(data, iv, secret, salt, length): Promise<ArrayBuffer> {
    return new Promise((resolve, reject) => {
      this.generateKey(secret, salt, length).then(
        (key: CryptoKey) => {
          return window.crypto.subtle.encrypt({ name: "AES-CBC", iv: iv }, key, data ).then(data => resolve(data))
        }).catch(error => reject(error));
      });
  }

  private generateKey(secret, salt, length) {
    return new Promise(
      (resolve, _) => { 
        this.generateBits(secret, salt, length).then(bits => {
          window.crypto.subtle.importKey(
            "raw",
            bits,
            { "name": "AES-CBC", length: 256 },
            false,
            ["encrypt", "decrypt"]
          ).then(function(key) {
            resolve(key);
          });
        })
    });
  }
}
